export default __webpack_public_path__ + "static/media/10-3.a44788fa.mp3";